import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Stack, Text, mergeStyleSets, PrimaryButton } from '@fluentui/react';
import { FreeTrialBadge, PrivatePlanBadge } from '@shared/components';
import classNames from 'classnames';
import { NeutralColors } from '@fluentui/theme';
const classes = mergeStyleSets({
    planNameText: {
        minWidth: 144,
        maxWidth: 296,
        whiteSpace: 'break-spaces',
        fontWeight: 600,
        color: NeutralColors.gray160
    },
    hidden: {
        visibility: 'hidden'
    },
    getItNowButton: {
        marginTop: 16
    }
});
const FreeTrialBadgeItem = ({ sku })=>{
    return /*#__PURE__*/ _jsx(Stack.Item, {
        className: classNames({
            [classes.hidden]: !sku.freeTrialDurationDays
        }),
        children: /*#__PURE__*/ _jsx(FreeTrialBadge, {})
    });
};
const PrivateBadgeItem = ({ sku })=>{
    return /*#__PURE__*/ _jsx(Stack.Item, {
        className: classNames({
            [classes.hidden]: !sku.isPrivate
        }),
        children: /*#__PURE__*/ _jsx(PrivatePlanBadge, {})
    });
};
const Badges = ({ sku, offerHasFreeTrialPlans, offerHasPrivatePlans })=>{
    if (!offerHasFreeTrialPlans && !offerHasPrivatePlans) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Stack, {
        horizontal: true,
        tokens: {
            childrenGap: 8
        },
        children: [
            offerHasFreeTrialPlans && /*#__PURE__*/ _jsx(FreeTrialBadgeItem, {
                sku: sku
            }),
            offerHasPrivatePlans && /*#__PURE__*/ _jsx(PrivateBadgeItem, {
                sku: sku
            })
        ]
    });
};
export const SaasPlanNameCell = ({ offerHasPrivatePlans, offerHasFreeTrialPlans, sku, onGetInNowClicked }, context)=>{
    return /*#__PURE__*/ _jsxs(Stack, {
        horizontal: true,
        horizontalAlign: "space-between",
        tokens: {
            childrenGap: 16
        },
        children: [
            /*#__PURE__*/ _jsxs(Stack.Item, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: classes.planNameText,
                        block: true,
                        children: sku.title
                    }),
                    /*#__PURE__*/ _jsx(PrimaryButton, {
                        className: classes.getItNowButton,
                        text: context.loc('CTA_Get', 'Get it now'),
                        onClick: onGetInNowClicked
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Badges, {
                sku: sku,
                offerHasFreeTrialPlans: offerHasFreeTrialPlans,
                offerHasPrivatePlans: offerHasPrivatePlans
            })
        ]
    });
};
SaasPlanNameCell.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
